<template>
  <div style="width: 100%">
    <el-select
      v-model="data"
      :filterable="true"
      :remote="true"
      :remote-method="getData"
      @change="dataChange"
      value-key="Key"
      style="width: 100%"
      size="small"
      :clearable="clearable"
      @clear="dataChange"
      :disabled="readonly"
      placeholder="输入编号/姓名/手机号搜索检测"
    >
      <el-option
        v-for="item in datas"
        :key="item.Key"
        :label="checkLabel(item)"
        :value="item"
      >
        <div class="proItem">
          <div class="name">{{ item.Code }} - {{ item.Member && item.Member.RealName }}</div>
          <div class="companys">
            <div class="company">
              {{ item.Tenant && item.Tenant.Name }}
              <span v-if="item.Member && item.Member.Mobile"> / {{ item.Member.Mobile }}</span>
            </div>
          </div>
        </div>
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { getPageList } from "@/api/check/check";
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      default: "",
    },
    clearable: {
      default: true,
    },
    readonly: {
      default: false,
    },
    tenant: {
      default: "",
    },
  },
  data() {
    return {
      datas: [],
      data: "",
    };
  },
  watch: {
    value: {
      handler(v) {
        this.data = v;
        if (this.data && this.data.Key) {
          let findObj = this.datas.find((r) => r.Key == this.data.Key);
          if (!findObj) {
            this.datas.push(this.data);
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    checkLabel(item) {
      if (!item) return "";
      const name = item.Member ? item.Member.RealName : "";
      const shop = item.Tenant ? item.Tenant.Name : "";
      return `${item.Code || ""} ${name} ${shop}`.trim();
    },
    getData(search) {
      let param = {
        pageIndex: 1,
        pageSize: 20,
        tenant: this.tenant || "",
        status: "",
        source: "",
        agePeriod: "",
        dateType: "",
        beginDate: "",
        endDate: "",
        search: search || "",
      };
      getPageList(param).then((res) => {
        if (res) {
          this.datas = res.Items || [];
        }
      });
    },
    dataChange(v) {
      this.$emit("change", v);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
.el-select-dropdown__item {
  height: auto !important;
}
</style>
<style lang="scss" scoped>
.proItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .companys {
    .company {
      font-size: 10px;
      line-height: 16px;
      color: silver;
      margin-bottom: 10px;
      font-weight: normal;
    }
  }
}
</style>
